"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pager = exports.PageIndicatorPosition = exports.PageIndicatorType = void 0;
var react_1 = __importDefault(require("react"));
var _1 = require(".");
var distillUtilityClasses_1 = __importDefault(require("../../utility/distillUtilityClasses"));
var PageIndicatorType;
(function (PageIndicatorType) {
    PageIndicatorType["CurrentPage"] = "current-page";
    PageIndicatorType["CurrentPageAndTotal"] = "current-page-and-total";
    PageIndicatorType["Range"] = "range";
})(PageIndicatorType = exports.PageIndicatorType || (exports.PageIndicatorType = {}));
var PageIndicatorPosition;
(function (PageIndicatorPosition) {
    PageIndicatorPosition["Before"] = "before";
    PageIndicatorPosition["Between"] = "between";
    PageIndicatorPosition["After"] = "after";
})(PageIndicatorPosition = exports.PageIndicatorPosition || (exports.PageIndicatorPosition = {}));
/** https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#sequence_generator_range */
var range = function (start, stop) {
    var arrayLike = { length: stop - start + 1 };
    return Array.from(arrayLike, function (_value, index) { return start + index; });
};
var DEFAULT_MIN_SIBLINGS = 1;
var DEFAULT_MIN_BOUNDARY = 1;
var Pager = function (props) {
    var _a, _b;
    var utilityClasses = distillUtilityClasses_1.default(props)[0];
    var classes = __spreadArray(["c-pager"], utilityClasses);
    // Sometimes number of pages is passed as NaN - let's presume there's only 1 page then!
    var numberOfPages = isNaN(props.numberOfPages) ? 1 : props.numberOfPages;
    if (isNaN(props.currentPage)) {
        props.currentPage = 1;
    }
    var currentPage = Math.min(props.currentPage, numberOfPages);
    var onFirstPage = currentPage <= 1;
    var onLastPage = currentPage >= numberOfPages;
    /** REPRESENTATION OF PAGER ITEMS */
    // Page numbers higher than the number of pages are invalid.
    // Items to always show at the starting boundary
    var boundaryPageCount = (_a = props.minBoundaryPageCount) !== null && _a !== void 0 ? _a : DEFAULT_MIN_BOUNDARY;
    var siblingPageCount = (_b = props.minSiblingPageCount) !== null && _b !== void 0 ? _b : DEFAULT_MIN_SIBLINGS;
    var startOfRangePages = range(1, Math.min(boundaryPageCount, numberOfPages));
    // Items to always show at the ending boundary. Might be empty for small numbers of pages
    var endOfRangePages = range(Math.max(numberOfPages - boundaryPageCount + 1, boundaryPageCount + 1), numberOfPages);
    // TODO explanation of this
    var firstSiblingPageNumber = Math.max(Math.min(currentPage - siblingPageCount, numberOfPages - boundaryPageCount - siblingPageCount * 2 - 1), boundaryPageCount + 2);
    var lastSiblingPageNumber = Math.min(Math.max(currentPage + siblingPageCount, boundaryPageCount + siblingPageCount * 2 + 2), endOfRangePages.length > 0 ? endOfRangePages[0] - 2 : numberOfPages - 1);
    var items;
    switch (props.pageIndicatorType) {
        case PageIndicatorType.CurrentPageAndTotal:
            items = [currentPage + " of " + numberOfPages];
            break;
        case PageIndicatorType.Range:
            items = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], startOfRangePages), (firstSiblingPageNumber > boundaryPageCount + 2
                ? ["ellipsis"]
                : boundaryPageCount + 1 < numberOfPages - boundaryPageCount
                    ? [boundaryPageCount + 1]
                    : [])), range(firstSiblingPageNumber, lastSiblingPageNumber)), (lastSiblingPageNumber < numberOfPages - boundaryPageCount - 1
                ? ["ellipsis"]
                : numberOfPages - boundaryPageCount > boundaryPageCount
                    ? [numberOfPages - boundaryPageCount]
                    : [])), endOfRangePages);
            break;
        case PageIndicatorType.CurrentPage:
        // Intentional fall-through
        default:
            items = [currentPage.toString()];
    }
    var pagerItems = items.map(function (item) {
        var pagerItemProps = {
            disabled: props.disabled,
            key: item,
        };
        if (item === "ellipsis") {
            pagerItemProps.type = "spacer";
            pagerItemProps.children = "…";
        }
        else {
            pagerItemProps.children = item;
            if (typeof item === "number") {
                pagerItemProps.selected = item === currentPage;
                pagerItemProps.onClick = function () { return props.onPageChange(item); };
            }
        }
        return pagerItemProps;
    });
    return (react_1.default.createElement("nav", { "aria-label": "pagination" },
        react_1.default.createElement("ul", { className: classes.join(" ") },
            props.pageIndicatorPosition === PageIndicatorPosition.Before &&
                pagerItems.map(function (page) { return react_1.default.createElement(_1.PagerItem, __assign({}, page, { key: page.key })); }),
            props.showFirstButton && (react_1.default.createElement(_1.PagerItem, { disabled: onFirstPage || props.disabled, type: "first", key: "first", onClick: function () { return props.onPageChange(1); } }, "\u21E4")),
            !props.hidePreviousButton && (react_1.default.createElement(_1.PagerItem, { disabled: onFirstPage || props.disabled, type: "prev", key: "prev", onClick: function () { return props.onPageChange(currentPage - 1); } }, "\u2039")),
            (props.pageIndicatorPosition === PageIndicatorPosition.Between ||
                !props.pageIndicatorPosition) &&
                pagerItems.map(_1.PagerItem),
            !props.hideNextButton && (react_1.default.createElement(_1.PagerItem, { disabled: onLastPage || props.disabled, type: "next", key: "next", onClick: function () { return props.onPageChange(currentPage + 1); } }, "\u203A")),
            props.showLastButton && (react_1.default.createElement(_1.PagerItem, { disabled: onLastPage || props.disabled, type: "last", key: "last", onClick: function () { return props.onPageChange(numberOfPages); } }, "\u21E5")),
            props.pageIndicatorPosition === PageIndicatorPosition.After &&
                pagerItems.map(_1.PagerItem))));
};
exports.Pager = Pager;
//# sourceMappingURL=Pager.js.map